export class StreamClosedWithError extends Error {
  constructor() {
    super("Stream closed with error");
  }
}
